import React from "react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import {
    SSO_CLIENT_ID,
    SSO_DOMAIN,
    SSO_REDIRECT_URL,
} from "../../../constants";


const msalConfig: Configuration = {
    auth: {
        clientId: SSO_CLIENT_ID,
        redirectUri: SSO_REDIRECT_URL,
        knownAuthorities: [SSO_DOMAIN],
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    }
};

// MSAL must be initialized lazily to avoid accessing browser-only APIs
// (e.g. window.crypto) during Jest/Node test execution
let msalInstance: PublicClientApplication | null = null;

const getMsalInstance = () => {
    if (!msalInstance) {
        msalInstance = new PublicClientApplication(msalConfig);
    }

    return msalInstance;
};

export function MsalContextProvider({ children }: React.PropsWithChildren<unknown>) {
    return (
        <MsalProvider instance={getMsalInstance()}>
            {children}
        </MsalProvider>
    );
}
